import api from '../../services/api';
import { Creators } from '../ducks/contact_type';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getContactTypes({ filter }) {
  try {
    yield put(Creators.contactTypeRequest());
    const response = yield call(api.post, 'contact-type', filter);

    yield put(Creators.contactTypeSuccess(filter.chip, response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.contactTypeError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao listar tipos de contato'
    }));
  }
}